import React from 'react'
import styled from '@emotion/styled'
import Spinner from '../generic/spinner.js'

export default ({ experienceState }) => {
  const { theme } = experienceState || {}

  return (
    <LoadingDiv>
      <Spinner theme={theme} size="30px" />
    </LoadingDiv>
  )
}

const LoadingDiv = styled.div`
  padding-top: 100px;
  display: flex;
  justify-content: center;
  height: 100vh;
`
